<template>
  <div>
    <div  class="breadcumb-area bg-img" :style="'background-image: url(' + require('@/assets/slider/1.jpg') +'); background-position-y:20%'">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12 col-md-6 p-4">
                    <div class="breadcumb-text">
                        <h5>Iglesia</h5>                        
                        <h2>La Senda Antigua</h2>                        
                        <p>
                          Paraos en los caminos, y mirad, y preguntad por las sendas antiguas, cuál sea el buen camino, y andad por él, y hallaréis descanso para vuestra alma
                          <strong>Jeremías 6:16</strong>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="faith-about-area section-padding-100-0">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="about-content">
                        <!-- <img src="img/core-img/cross.png" alt=""> -->
                        <!-- <h2>Iglesia La Senda Antigua</h2> -->
                        <h6 class="text-justify">
                          Iglesia La Senda Antigua le saluda. Somos una congregación de cristianos que está buscando vivir a la luz del camino antiguo, como lo denota Jeremías 6:16, donde se le exhorta al pueblo de Dios que pregunte por las sendas antiguas. Al mencionar las sendas antiguas nos referimos a los principios bíblicos que ministraron los apóstoles y los padres espirituales de la fe una vez dada a los santos.
                        </h6>

                        <blockquote class="text-justify m-3 mt-5 mb-5 text-secondary" >
                          <i>
                            Así dijo Jehová: Paraos en los caminos, y mirad, y preguntad por las sendas antiguas, cuál sea el buen camino, y andad por él, y hallaréis descanso para vuestra alma. Mas dijeron: No andaremos. Jeremías 6:16 RV1960
                          </i>
                        </blockquote>

                        <h6 class="text-justify">
                          Nuestro deseo es poder responder al Señor, atender a su instrucción de mirar atentamente a los caminos de nuestros antepasados y preguntar en la historia cristiana, cuál es el Camino de Dios y seguirlo. Únase con nosotros mientras adoramos y ministramos a nuestro Maravilloso Salvador y aprendamos juntos el Camino que Dios ha trazado ¡de la tierra a la Gloria!
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <our-faith/>
  </div>
</template>

<script>

import OurFaith from "@/components/OurFaith";

export default {
    components:{
        OurFaith,
    }
}
</script>

<style>

</style>